const ADD_TO_BASKET_PHRASES = [
  "dodano do koszyka",
  "dodano bilet do koszyka",
  "dodano bilety do koszyka",
  "added to cart",
  "added to the cart",
  "added to basket",
  "ticket added to the cart",
  "zum warenkorb hinzugefügt",
  "karte wurde zum warenkorb hinzugefügt",
  "додано до кошика",
  "квиток додано в кошик",
];

const ADD_TO_BASKET_PATTERN =
  /(dodan\w*|added|hinzugefüg\w*|додано).{0,80}(koszyk|cart|basket|warenkorb|кошик)|(koszyk|cart|basket|warenkorb|кошик).{0,80}(dodan\w*|added|hinzugefüg\w*|додано)/i;

const normalizeInfoMessage = (message: string): string =>
  message.replace(/\s+/g, " ").trim().toLowerCase();

export const isAddToBasketInfoMessage = (message: unknown): boolean => {
  if (typeof message !== "string") {
    return false;
  }

  const normalized = normalizeInfoMessage(message);
  if (!normalized) {
    return false;
  }

  if (ADD_TO_BASKET_PHRASES.some((phrase) => normalized.includes(phrase))) {
    return true;
  }

  return ADD_TO_BASKET_PATTERN.test(normalized);
};

export const splitApiInfoMessages = (
  messages: string[] | null | undefined
): { addToBasket: string[]; hidden: string[] } => {
  const list = (messages ?? []).filter((item): item is string => typeof item === "string" && item.trim() !== "");

  return {
    addToBasket: list.filter(isAddToBasketInfoMessage),
    hidden: list.filter((item) => !isAddToBasketInfoMessage(item)),
  };
};
